export const USUARIO = 'USUARIO'
export const usuario_action = (data) =>{
    return{
        type:USUARIO,
        payload:data
    }
}